/**
 * Loading fallback displayed inside Suspense boundaries while
 * lazy-loaded route components are being fetched.
 */
export default function PageLoadingFallback() {
  return (
    <div className="flex items-center justify-center h-64">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" />
    </div>
  )
}
